import { useEffect, useState } from "react";
import { useFetch } from "../../utils/useFetch";
import { getQuery } from "../../utils/Url";
import FetchOptions from "../../utils/FetchOptions";
import { useTranslation } from "react-i18next";

export default function useGarminConnect() {
    const { t } = useTranslation();
    const [garminConnectConnectionInfo, setGarminConnectConnectionInfo] = useState(null);
    const { apiPost, ApiErrors } = useFetch();
    const [garminApiError, setGarminApiError] = useState(null);
    const [isConnecting, setIsConnecting] = useState(false);
    const query = getQuery();

    async function connect(returnUrlQueryString) {
        setIsConnecting(true);
        window.location =
            FetchOptions.apiUrl +
            "/garmin/connect?ReturnUrl=" +
            encodeURIComponent(
                `${window.location.protocol}//${window.location.host}${window.location.pathname}${
                    returnUrlQueryString ? `?${returnUrlQueryString}` : ""
                }`,
            );
    }

    async function disconnect() {
        const response = await apiPost("/garmin/disconnect");
        if (response.isOk) await getStatus();
    }

    async function getStatus() {
        const response = await apiPost("/garmin/get-state");
        if (response.isOk) {
            setGarminConnectConnectionInfo(response.json || {});
        }
    }

    useEffect(() => {
        getStatus();

        const gcErrorCode = query.get("gc-error");
        if (gcErrorCode !== null) {
            switch (gcErrorCode) {
                case "get-consent":
                    setGarminApiError(t("extConnectors.Error.GetConsent"));
            }
        }
    }, []);

    return {
        connect,
        disconnect,
        garminConnectConnectionInfo,
        isConnecting,
        ApiErrors,
        garminApiError,
    };
}
